export default __webpack_public_path__ + "static/media/Polaroid_Loop_v001_1.b5a35ff3.gif";